/**
 * 后台菜单 / 路由名 —— English
 * key 必须与 zh-CN/menu.ts 逐条对应（对账脚本会查差集）
 */
export default {
  'menu.控制台': 'Dashboard',
  '控制台': 'Dashboard',
  'menu.在线用户': 'Online Users',
  '在线用户': 'Online Users',
  'menu.角色管理': 'Roles',
  '角色管理': 'Roles',
  'menu.权限管理': 'Permissions',
  '权限管理': 'Permissions',
  'menu.管理员管理': 'Administrators',
  '管理员管理': 'Administrators',
  'menu.企业管理': 'Companies',
  '企业管理': 'Companies',
  'menu.编辑企业': 'Edit Company',
  '编辑企业': 'Edit Company',
  'menu.企业管理员': 'Company Admins',
  '企业管理员': 'Company Admins',
  'menu.导航管理': 'Navigation',
  '导航管理': 'Navigation',
  'menu.文章分类管理': 'Article Categories',
  '文章分类管理': 'Article Categories',
  'menu.SEO管理': 'SEO',
  SEO管理: 'SEO',
  'menu.文章管理': 'Articles',
  '文章管理': 'Articles',
  'menu.手工写作': 'Manual Writing',
  '手工写作': 'Manual Writing',
  'menu.编辑文章': 'Edit Article',
  '编辑文章': 'Edit Article',
  'menu.AI智能写作': 'AI Writing',
  AI智能写作: 'AI Writing',
  'menu.全站搜索': 'Site Search',
  '全站搜索': 'Site Search',
  'menu.全球支付': 'Global Payment',
  '全球支付': 'Global Payment',
  'menu.会员展示': 'Member Directory',
  '会员展示': 'Member Directory',
  'menu.我的企业官网': 'My Company Site',
  '我的企业官网': 'My Company Site',
  'menu.总裁助理': 'CEO Assistant',
  '总裁助理': 'CEO Assistant',
  'menu.敏感词管理': 'Banned Words',
  '敏感词管理': 'Banned Words',
  'menu.短信记录管理': 'SMS Records',
  '短信记录管理': 'SMS Records',
  'menu.引擎管理': 'Engine',
  '引擎管理': 'Engine',
  'menu.AI文章成本记录': 'AI Article Costs',
  AI文章成本记录: 'AI Article Costs',
  'menu.成本记录': 'Cost Records',
  '成本记录': 'Cost Records',
  'menu.企庭中国民营经济网配置': 'chpen.com Settings',
  '企庭中国民营经济网配置': 'chpen.com Settings',
  'menu.公司官网配置': 'Company Site Config',
  '公司官网配置': 'Company Site Config',
  'menu.区域站点': 'Regional Sites',
  '区域站点': 'Regional Sites',
  'menu.省份管理': 'Provinces',
  '省份管理': 'Provinces',
  'menu.城市管理': 'Cities',
  '城市管理': 'Cities',
  'menu.区域管理': 'Districts',
  '区域管理': 'Districts',
  'menu.提现审核': 'Withdrawals',
  '提现审核': 'Withdrawals',
  'menu.交易记录': 'Transactions',
  '交易记录': 'Transactions',
  'menu.通讯录': 'Address book',
  'menu.客户系统': 'Customer System',
  '客户系统': 'Customer System',
  'menu.自然人': 'Natural Persons',
  '自然人': 'Natural Persons',
  '自然人管理': 'Natural Persons',
  'menu.充值管理': 'Recharge',
  '通讯录': 'Address book',
  '充值管理': 'Recharge',

  // 站点标题 / 布局
  'chpen.com 管理后台': 'chpen.com Admin',
  '管理后台': 'Admin',
  '注销名册': 'Closure Register',
};
